<template>
  <Form ref="jobsInfoForm" :model="jobsInfo" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="jobsInfo.id" type="hidden"/>

    <FormItem  :label="this.$t('property.jobs-info.name.label')" prop="name">
      <Input v-model="jobsInfo.name" :placeholder="$t('property.jobs-info.name.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('property.jobs-info.remark.label')" prop="remark">
      <Input v-model="jobsInfo.remark" :placeholder="$t('property.jobs-info.remark.holder')"/>
    </FormItem>

    <div v-if="actionType=='detail'">
      <FormItem  :label="this.$t('property.jobs-info.createTime.label')" prop="createTime">
        <Date-picker disabled v-model="jobsInfo.createTime" type="datetime"  :placeholder="this.$t('property.jobs-info.createTime.holder')"></Date-picker>
      </FormItem>
    </div>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      jobsInfo: {
        id: null,
        name: null,
        remark: null,
        createTime: null
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['jobsInfoForm'].validate(valid => {
        if (valid) {
          if (this.jobsInfo.id) {
            this.updateJobsInfo(this.jobsInfo).then(then).error(error)
          } else {
            this.createJobsInfo(this.jobsInfo).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.jobsInfo.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['jobsInfoForm'].resetFields());
    },
    getJobsInfo(id,type){
      this.loading = true;
      this.$refs['jobsInfoForm'].resetFields()
      api.property.JobsInfo.detail(id).then(data => {
        this.jobsInfo = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createJobsInfo(jobsInfo){
      this.loading = true;
      return api.property.JobsInfo.add(jobsInfo)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateJobsInfo(jobsInfo){
      this.loading = true;
      return api.property.JobsInfo.update(jobsInfo)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      name: [{type: 'string', required: true, message: this.$t('property.jobs-info.name.required'),trigger: 'blur'}, {type: 'string',max: 50, message: this.$t('property.jobs-info.name.max'),trigger: 'blur'}],
      remark: [{type: 'string',max: 255, message: this.$t('property.jobs-info.remark.max'),trigger: 'blur'}],
     }
      if(this.actionType == 'edit'){
        this.$refs['jobsInfoForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
